import type { Login } from "../../types/Login.js";

export const login: Login = ({ password, state, username }) => {
  state.userTrackedPromise.run({ password, username });

  // we may want to add a return tracked promise here
  // just because of the tests... =(
  // may help with that one where we need to await next ticks
  // we need to check
};
